import React, { Fragment, useState } from 'react'
import { Document, Page } from 'react-pdf'

import { pdfjs } from 'react-pdf'
import KullanimKlavuzu from './FR.109-Raporlama-Sistemi-Müşteri-Bilgilendirme-Formu.pdf'
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version
    }/pdf.worker.js`

export default function PdfViewer() {
    const [numPages1, setNumPages] = useState(null)
    const [fileUrl, setFileUrl] = useState(KullanimKlavuzu);
    function OnDocumentLoadSuccess(document) {
        const { numPages } = document
        // this.setState({
        //     numPages
        // })
        setNumPages(numPages)
    }
    // function handleUrlChange(){
    //     // const { fileUrl } = this.state
    //     const newUrl = fileUrl === samplePDF ? anotherSamplePdf : samplePDF
    //     this.setState({
    //         fileUrl: newUrl
    //     })
    // }
    return <Fragment>
        {/* <button onClick={this.handleUrlChange}>Toggle PDF URL</button> */}
        <Document
            // key={fileUrl} // optional, doesn't affect things
            file={fileUrl}
            onLoadSuccess={OnDocumentLoadSuccess}
        >
            {Array.from(new Array(numPages1), (el, index) => (
                <Page
                    key={`page_${index + 1}`}
                    pageNumber={index + 1}
                    width={900}
                />
            ))}
        </Document>
    </Fragment>
}

